import {
  frontendConfig,
  parsedFrontendConfig,
} from 'frontend/shared/javascripts/util/frontend_config'

const config = (parsedFrontendConfig('playerConfigEnv') as Record<string, any> | null) ?? {}
config.ima_sdk_url = frontendConfig('imaSdkUrl')

export default config
